// Thin analytics wrapper. Today it logs to the console; a real sink (e.g.
// Segment/Amplitude) plugs in here in Sprint 1 without touching any caller.
//
// Props are a flat string map by design: callers pass categorical dimensions
// (kind, result, …) — never raw personal data such as a phone or a name.
export type AnalyticsProps = Record<string, string>;

export function track(event: string, props: AnalyticsProps): void {
  // eslint-disable-next-line no-console
  console.info('[analytics]', event, props);
}
